import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import VideoGrid from '@/pages/home/components/VideoGrid';
import { videos, categories } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = useMemo(() => categories.find((c) => c.slug === slug), [slug]);

  const categoryVideos = useMemo(() => {
    if (!slug) return [];
    return videos.filter((v) => v.category === slug);
  }, [slug]);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
              <i className="ri-error-warning-line text-3xl text-foreground-300"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-900 mb-2">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-20 pb-12">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
          <div className="mb-4">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: category.label },
              ]}
            />
          </div>

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10">
                <i className={`${category.icon} text-xl text-primary-500`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                {category.label}
              </h1>
            </div>
            <p className="text-foreground-500 text-sm">
              共找到 {categoryVideos.length} 部{category.label}作品
            </p>
          </div>

          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-white border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                  <i className={cat.icon}></i>
                </span>
                {cat.label}
              </Link>
            ))}
          </div>

          <VideoGrid videos={categoryVideos} />
        </div>
      </main>
      <Footer />
    </>
  );
}